<svg
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  [attr.viewBox]="viewBoxString"
  preserveAspectRatio="xMinYMin"
  class="cabinet-section-2d swing-2d"
  (click)="selectSwingArea(null); $event.preventDefault()"
>
  <g class="ruler-view" *ngIf="showRulers">
    <g *ngFor="let ruler of rulers">
      <g
        class="ruler vertical-ruler"
        *ngIf="ruler.isVertical"
        attr.transform="translate( {{ ruler.svgStart.X }} {{
          ruler.svgStart.Y
        }} )"
      >
        <line
          class="ruler-line ruler-serif"
          style="stroke: black; stroke-width: 3px"
          [attr.x1]="-ruler.serifSize"
          [attr.x2]="ruler.serifSize"
          y1="0"
          y2="0"
        />
        <line
          class="ruler-line ruler-serif"
          style="stroke: black; stroke-width: 3px"
          [attr.x1]="-ruler.serifSize"
          [attr.x2]="ruler.serifSize"
          [attr.y1]="-ruler.length"
          [attr.y2]="-ruler.length"
        />
        <line
          class="ruler-line ruler-main-line"
          style="stroke: black; stroke-width: 3px"
          y1="0"
          [attr.y2]="-ruler.length"
          x1="0"
          x2="0"
        />
        <text
          class="ruler-text"
          style="font-size: 50px"
          x="-10px"
          [attr.y]="-ruler.length / 2"
          attr.transform="rotate( -90 0 {{ -ruler.length / 2 }} )"
          text-anchor="middle"
        >
          {{ ruler.length.toFixed(0) }}
        </text>
      </g>

      <g
        class="ruler horizontal-ruler"
        *ngIf="!ruler.isVertical"
        attr.transform="translate( {{ ruler.svgStart.X }} {{
          ruler.svgStart.Y
        }} )"
      >
        <line
          class="ruler-line ruler-serif"
          style="stroke: black; stroke-width: 3px"
          x1="0"
          x2="0"
          [attr.y1]="-ruler.serifSize"
          [attr.y2]="ruler.serifSize"
        />
        <line
          class="ruler-line ruler-serif"
          style="stroke: black; stroke-width: 3px"
          [attr.x1]="ruler.length"
          [attr.x2]="ruler.length"
          [attr.y1]="-ruler.serifSize"
          [attr.y2]="ruler.serifSize"
        />
        <line
          class="ruler-line ruler-main-line"
          style="stroke: black; stroke-width: 3px"
          x1="0"
          [attr.x2]="ruler.length"
          y1="0"
          y2="0"
        />
        <text
          class="ruler-text"
          style="font-size: 50px"
          y="-10px"
          [attr.x]="ruler.length / 2"
          text-anchor="middle"
        >
          {{ ruler.length.toFixed(0) }}
        </text>
      </g>
    </g>
  </g>

  <g class="front-view">
    <rect
      class="cabinet-section-border"
      x="0"
      y="0"
      width="0"
      height="0"
      style="fill: none; stroke: black; stroke-width: 3px"
      [attr.width]="cabinetSection.interior.cube.Width"
      [attr.height]="cabinetSection.interior.cube.Height"
      [attr.x]="cabinetSection.interior.cube.X"
      [attr.y]="
        cabinetSection.Height -
        cabinetSection.interior.cube.Height -
        cabinetSection.interior.cube.Y
      "
    ></rect>

    <g *ngFor="let item of swingItems">
      <g
        *ngIf="isItemDisplayed(item)"
        [app-interior-item]="item"
        class="item"
      ></g>
    </g>

    <g class="item-rulers" *ngIf="showRulers">
      <g *ngFor="let item of swingItems">
        <g
          class="item-ruler-overlay"
          [app-interior-item]="item"
          [showItem]="false"
          *ngIf="shouldDisplayRulerFor(item)"
        >
          <rect
            class="item-ruler-background"
            width="0"
            style="fill: rgba(255, 255, 255, 0.5)"
            height="0"
            [attr.width]="itemRulerBackgroundWidth"
            [attr.height]="itemRulerBackgroundHeight"
            [attr.x]="(item.Width - itemRulerBackgroundWidth) / 2"
            [attr.y]="(item.Height - itemRulerBackgroundHeight) / 2"
          ></rect>

          <text
            class="item-ruler-text"
            style="font-size: 40px; pointer-events: none"
            [attr.x]="item.Width / 2"
            [attr.y]="item.Height / 2 + 13"
            text-anchor="middle"
          >
            {{ item.PositionNumber }}
          </text>
        </g>
      </g>
    </g>

    <g class="swing-area-overlays">
      <rect
        *ngFor="let swingArea of swingAreas"
        class="select-marker swing-select-marker"
        [class]="{ selected: isSwingAreaSelected(swingArea) }"
        style="opacity: 0"
        (click)="selectSwingArea(swingArea); $event.stopPropagation()"
        x="0"
        y="0"
        width="0"
        height="0"
        [attr.x]="swingArea.insideRect.X"
        [attr.y]="
          sectionHeight - swingArea.insideRect.Y - swingArea.insideRect.Height
        "
        [attr.width]="swingArea.insideRect.Width"
        [attr.height]="swingArea.insideRect.Height"
      ></rect>
    </g>
  </g>

  <g
    class="swing-door-view"
    attr.transform="translate(0, {{ cabinetSection.Height + 10 }})"
    *ngIf="showTopdown"
  >
    <g *ngFor="let door of doors">
      <line
        x1="0"
        y1="0"
        x2="0"
        y2="0"
        [attr.x1]="door.pos1.X"
        [attr.y1]="door.pos1.Y"
        [attr.x2]="door.pos2.X"
        [attr.y2]="door.pos2.Y"
        stroke="black"
        style="stroke-width: 19"
      ></line>
    </g>
  </g>
</svg>
